
// import { getNoticeList } from '@/api/system';
import { getQiniuToken } from '@/api/third';
import { UserModule } from '@/store/modules/user';
import { Type } from '@/types/permissionType';
import { Qiniu } from '@/types/qiniu';
import { checkPermissionUseAndCompany } from '@/utils/permission';
import { makeKey } from '@/utils/qiniu';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
// import { UserModule } from '@/store/modules/user';
import Tinymce from '../../announcements/Tinymce/index.vue';

@Component({
  name: '',
  components: {
    Tinymce
  }
})
export default class extends Vue {
  @Prop({
    type: Object,
    default: () => ({}),
    required: true
  })
  currentData!: any;

  // company_introduction 公司介绍  picture_ad 图片广告   company_notice 公司公告   picture_navigation 图文导航    video_card 视频卡片    title_text 标题文本   article_text 正文文本

  private formCompany: any = {
    "logo_is_show": 1,
    "name_is_show": 1,
    "mobile_is_show": 1,
    "address_is_show": 1

  }

  private qiniuBean:any = { token: '', key: '', default_url: '', domain: '', action_url: '' }
  private qiuniuform = {};

  private defaultImgUrl = 'this.src="' + require('@/assets/images/door-upload.png') + '"'

  private formAnnouncement: any = {
    text: ''
  }
  private announcement:any = [];

  // 固定数据
  private navOptions = [{
    title: '扫码报修',
    icon: 'scan_report',
    url: 'scan_report'
  }, {
    title: '我的订单',
    icon: 'order_list',
    url: 'order_list'
  }, {
    title: '我要报修',
    icon: 'report_order',
    url: 'report_order'
  },
 {
    title: '待验收订单',
    icon: 'unconfirmed_order',
    url: 'unconfirmed_order'
  },
  {
    title: '待评价订单',
    icon: 'unevaluated_order',
    url: 'unevaluated_order'
  },
   {
    title: '服务热线',
    icon: 'service_hotline',
    url: 'service_hotline'
  }, {
    title: '我的设备',
    icon: 'device_list',
    url: 'device_list'
  }, {
    title: '公司公告',
    icon: 'company_notice',
    url: 'company_notice'
  }, {
    title: '安装交付',
    icon: 'install_apply',
    url: 'install_apply'
  }]
  private defaultLinkImg = require('@/assets/images/door-nav-default.png')

  private currentD: any = {
    'obj': {
      list: []
    }
  }

  @Watch('currentData', {
    deep: true,
    immediate: true
  })
  handleChangePropsDataType() {
    this.currentD = {
      'obj': {
        list: []
      }
    };
    if (this.currentData && this.currentData.key) {
      this.currentD = this.currentData;
      if (this.currentD.obj && this.currentD.obj.control_show) {
        this.$set(this.formCompany, 'logo_is_show', parseInt(this.currentD.obj.control_show.logo_is_show) === 1)
        this.$set(this.formCompany, 'name_is_show', parseInt(this.currentD.obj.control_show.name_is_show) === 1)
        this.$set(this.formCompany, 'mobile_is_show', parseInt(this.currentD.obj.control_show.mobile_is_show) === 1)
        this.$set(this.formCompany, 'address_is_show', parseInt(this.currentD.obj.control_show.address_is_show) === 1)
      }
    }
  }
  created() {
    const params = {
      type: Qiniu.UPLOAD_TYPE_COMPANY,
    };
    getQiniuToken(params).then((res) => {
      if (res && res.data) {
        this.qiniuBean = res.data;
      }
    });
    // this.getNoticeList()
  }
  
  
  private logoIsShowChange(val:any) {
    this.currentD.obj.control_show.logo_is_show = this.formCompany.logo_is_show ? 1 : 0;
  }
  private nameIsShowChange(val:any) {
    this.currentD.obj.control_show.name_is_show = this.formCompany.name_is_show ? 1 : 0;
  }
  private mobileIsShowChange(val:any) {
    this.currentD.obj.control_show.mobile_is_show = this.formCompany.mobile_is_show ? 1 : 0;
  }
  private addressIsShowChange(val:any) {
    this.currentD.obj.control_show.address_is_show = this.formCompany.address_is_show ? 1 : 0;
  }

  private linkImgSrc(value: any) {
    switch (value) {
      case 'scan_report':
        value = require('@/assets/images/door-nav-scan.png');
        break;
      case 'order_list':
        value = require('@/assets/images/door-nav-order.png');
        break;
      case 'report_order':
        value = require('@/assets/images/door-nav-create.png');
        break;
      case 'unconfirmed_order':
        value = require('@/assets/images/door-nav-unconfirmed.png');
        break;
      case 'unevaluated_order':
        value = require('@/assets/images/door-nav-unevaluated.png');
        break;
      case 'service_hotline':
        value = require('@/assets/images/door-nav-hotline.png');
        break;
      case 'device_list':
        value = require('@/assets/images/door-nav-device.png');
        break;
      case 'company_notice':
        value = require('@/assets/images/door-nav-notice.png');
        break;
      case 'install_apply':
        value = require('@/assets/images/door-nav-install-apply.png');
        break;
      default:
        value = require('@/assets/images/door-nav-default.png');
        break;
    }
    return value;
  }

  private handleSuccessUpload(res:any, index:number) {
    this.currentD.obj.list[index].img_url = this.qiniuBean.default_url + res.key
    this.currentD.obj.list[index].img = res.key
  }
  private beforeUpload(file:any) {
    const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
    const isLt2M = file.size / 1024 / 1024 < 5;
    if (!isJPG) {
      return this.$message.error('上传文件只能是  JPG或PNG 格式!');
    }
    if (!isLt2M) {
      return this.$message.error('上传图片大小不能超过 5MB!');
    }
    return new Promise((resolve, reject) => {
      resolve(true);
    }).then(res => {
      let k = makeKey(this.qiniuBean.prekey);
      this.qiuniuform = {
        key: k,
        token: this.qiniuBean.uptoken,
        domain: this.qiniuBean.domain
      };
    });
  }

  // 添加图片广告
  private addpictureAdHandle() {
    if (!this.currentD.obj.list) {
      this.currentD.obj.list = []
    }
    this.currentD.obj.list.push({
      img: '',
      url: '',
    })
  }

  // 添加导航
  private addNavHandle() {
    this.currentD.obj.list.push({
      icon: '',
      title: '暂无',
      url: '',
    })
  }
  // 视频
  private handleVSuccessUpload(res:any) {
    this.$set(this.currentD.obj, 'img_url', this.qiniuBean.default_url + res.key)
    this.currentD.obj.img = res.key
  }

  private navPrevHandle(index: any) {
    let cut = this.currentD.obj.list[index];
    this.currentD.obj.list.splice(index, 1);
    this.currentD.obj.list.splice(index - 1, 0, cut);
  }
  private navNextHandle(index: any) {
    let cutArray = this.currentD.obj.list.filter((p:any) => {
      return p.icon
    })
    if (index < cutArray.length - 1) {
      let cut = this.currentD.obj.list[index];
      this.currentD.obj.list.splice(index, 1);
      this.currentD.obj.list.splice(index + 1, 0, cut);
    }
  }

  private deleteHandle(index: any) {
    this.currentD.obj.list.splice(index, 1)
  }

//   // 公司公告
//   private getNoticeList() {
//   // 1内部公告 2客户公告
//     const params:any = {
//       user_id: UserModule.getUserId,
//       company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
//       page: 1,
//       size: 9999,
//       notice_type: checkPermissionUseAndCompany(UserModule.getCompanyId, Type.CompanyNoticeInner) ? 1 : 2
//     };
//     getNoticeList(params)
//       .then((res) => {
//         if (res.data) {
//           if (res.data.list) {
//             this.announcement = []
//             res.data.list.forEach((element:any) => {
//               this.announcement.push({
//                 title: element.notice_title,
//                 id: element.id
//               })
//             });
//           }
//         } else {
//           this.announcement = [];
//         }
//       })
//       .catch((err) => {
//         let msg = err.msg;
//       });
//   }
}
